
import React from "react";
import "../Cards/card.css";
import { Card, Button } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { doc, deleteDoc } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";

const PopularCard = ({ val, isAdmin = false, onDelete }) => {
  const navigate = useNavigate();

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this tour?")) {
      try {
        await deleteDoc(doc(fireDB, "tours", val.id));
        if (onDelete) onDelete(val.id);
        alert("✅ Tour deleted successfully!");
      } catch (error) {
        console.error("Error deleting tour:", error);
        alert("❌ Failed to delete tour.");
      }
    }
  };

  const handleEdit = () => {
    navigate(`/admin/edit-tour/${val.id}`);
  };

  return (
    <Card className="rounded-2 shadow-sm popular h-100 d-flex flex-column">
      {/* Image with fixed height */}
      <div className="overflow-hidden" style={{ height: "200px" }}>
        <Card.Img
          variant="top"
          src={val.imageUrl || "https://via.placeholder.com/300x200"}
          className="card-img-top h-100 w-100 object-fit-cover"
          alt={val.location || "Tour"}
        />
      </div>

      <Card.Body className="d-flex flex-column flex-grow-1">
        <Card.Title className="mb-2">
          {val.location || "Untitled Location"}
        </Card.Title>

        <Card.Text className="small text-muted">
          {val.date ? `📅 ${val.date}` : "📅 Date not specified"}
        </Card.Text>

        <Card.Text className="description flex-grow-1">
          {val.description?.length > 100
            ? `${val.description.slice(0, 100)}...`
            : val.description}
        </Card.Text>

        {isAdmin && (
          <div className="mt-2 d-flex gap-2">
            <Button variant="outline-primary" size="sm" onClick={handleEdit}>
              Edit
            </Button>
            <Button variant="outline-danger" size="sm" onClick={handleDelete}>
              Delete
            </Button>
          </div>
        )}

        <NavLink
          className="btn btn-primary w-100 mt-3"
          to={`/tour-details/${val.id}`}
        >
          View Details
        </NavLink>
      </Card.Body>
    </Card>
  );
};

export default PopularCard;
